<form [formGroup]="form" class="flex flex-col">
    <section aria-labelledby="frn-filing-type">
        <h3 id="frn-filing-type" class="application-section-header">
            Application Type
        </h3>
        <hr class="mb-4" />

        <div class="flex flex-col w-full">
            <div class="w-full xl:w-6/12">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>CORES Registration Type</mat-label>
                    <mat-select formControlName="coresRegistrationType">
                        @for (
                            option of coresRegistrationTypeOptions;
                            track option.value
                        ) {
                            <mat-option [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="w-full xl:w-6/12">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>
                        Contact Address is Within US or Its Territories
                    </mat-label>
                    <mat-select formControlName="hasUsaContactAddress">
                        @for (option of yesNoOptions; track option.value) {
                            <mat-option [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </section>
</form>
